import * as React from 'react';

import { Box } from '~shared/components/Box';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconLockSvg } from './IconLockSvg';

export type IconDocumentProps = UseIconProps;

export function IconLock(props: IconDocumentProps) {
  const iconProps = useIcon(props);

  return <Box tagName={IconLockSvg} {...iconProps} />;
}
